<template>
  <div class="grey lighten-2" height>
    <v-card
    class="mx-auto"
    height="100vh"
    width="100vw"
  >
    <v-navigation-drawer
      class="green accent-4"
      dark
      permanent
      app
    >
      <v-list>
        <v-list-item
          v-for="item in route"
          :key="item.title"
          link
          :to="item.to"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
           <v-select
          :items="zaastry"
          placeholder="Available Devices"
          outlined
          flat
          color="white"
          dark
        ></v-select>
        </div>
      </template>
    </v-navigation-drawer>
      <v-row no-gutters>
       
        <v-col cols="12" xs="8" sm="8" md="8" lg="8" xl="8"> 
          <v-row class="pt-5" no-gutters style="width:100%;height:100vh;overflow-y:scroll;overflow-x:hidden">
        
        
         <v-col cols="12" xs="4" sm="4" md="4" lg="4" xl="4" v-for="i in items" :key="i.category" >
          <v-card 
          elevation="1"
          class="pa-2 ma-2"
          @click="addToSale(i.itemData.name,i.itemData.variations[0].itemVariationData.priceMoney.amount*0.01)" flat tile>
            <v-img class="" :src="i.itemData.description" height="100"/>
            <v-divider></v-divider>
            <v-card-title><h5>{{i.itemData.name}}</h5></v-card-title>
          </v-card>
        </v-col>
       
      
         
        </v-row>
       
        </v-col>
        
        <v-col cols="12" xs="4" sm="4" md="4" lg="4" xl="4" style="height:100vh">
          <v-card tile flat elevation="1" class="pa-3" height="94vh" >
            <v-row class="pa-2">
            <h3>Current Sale</h3>
            <v-spacer></v-spacer>
            <v-icon>mdi-chevron-down</v-icon>
            </v-row>
            <v-divider class="mt-2 pt-5"></v-divider>
             <v-row class="pa-2" v-for="i in sales" :key="i.name">
            <h3>{{i.name}}</h3>
            <v-spacer></v-spacer>
           <h3>${{i.price}}</h3>
           <v-spacer></v-spacer>
           <v-icon @click="removeFromSale(i.name)">mdi-delete</v-icon>
            </v-row>
          </v-card>   
          <!-- {{ totalprice.toFixed(2)}} -->
             <v-dialog
        transition="dialog-top-transition"
        max-width="600"
      
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn tile text v-bind="attrs"
            v-on="on" block class="green text-center" dark>charge ${{totalprice}}</v-btn>
         
        </template>
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="green"
              dark
              width="100%"
            >
              <v-row>
                <v-spacer></v-spacer>
                <p class="text-center text-h5 font-weight-bold">${{totalprice}}</p>
                <v-spacer></v-spacer>
              </v-row>
            </v-toolbar>
            <v-card-text>
              <div class="text-center text-h5 pa-2" @click="type='Card'">Pay with Card</div>
              <div class="text-center text-h5 pa-2" >--OR--</div>
              <div class="text-center text-h5 pa-2" @click="type='Terminal'">Checkout with Terminal</div>

            </v-card-text>
            <v-slide-y-reverse-transition>
                  <Pay v-if="type=='Card'" />
                  <div v-if="type=='Terminal'" class="ma-6">
                    <v-btn block color="green"  dark @click="checkout">SEND TO TERMINAL</v-btn>
                  </div>
            </v-slide-y-reverse-transition>
            
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="dialog.value = false"
              >Close</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
          
        </v-col>
      </v-row>

      <!-- Dialogue information for payment -->

     
    </v-card>
  </div>
</template>

<script>
// import Dev from '../components/Terminal/Dev.vue'
import axios from 'axios'
import Pay from './About.vue'
export default {
  components: { Pay },
  data(){
    return {
      items:[],
      sales:[],
      totalprice:0,
      dialog:false,
      route:[
      {name:"Home",icon:"mdi-home",to:"/"},
      {name:"Items",icon:"mdi-shopping-outline",to:"/terminalpos"},
      {name:"Devices",icon:"mdi-devices",to:"/terminalpos/devices"},
    ],
    type:"",
    zaastry:['Zaastry-2YAKJ0757Y6X','Zaastry-YBMNRF']
    }
  },
  methods:{
    addToSale(name,price){
      this.sales.push({name:name,price:price})
      this.totalprice+=price
      this.$store.commit("addTotalPrice",this.totalprice)
    },
    removeFromSale(name){
      let unsales=[]
      let total=0
      for(var i=0;i<this.sales.length;i++){
        if(this.sales[i].name!==name){
          unsales.push(this.sales[i])
          total+=this.sales[i].price
        }
      }
      this.sales=unsales;
      this.totalprice=total
      this.$store.commit("addTotalPrice",this.totalprice)
    },
    checkout(){
      axios.post('https://zaastry-node.herokuapp.com/checkout',{
        amount:Math.round(this.totalprice)
      }).then(res=>{
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    }
  },
mounted(){
  axios.get('https://zaastry-node.herokuapp.com/items').then(res=>{
    console.log(res.data)
    let newData=res.data
    for(var i=0;i<newData.length;i++){
      if(newData[i].type=="ITEM"){
        this.items.push(newData[i])
      }

    }
  console.log(this.items,"item")
  }).catch(err=>{
    console.log(err)
  })
}
}
</script>

<style>

</style>